let amaModulesCache: any = null;

export default function getModules() {
  if (amaModulesCache) {
    return amaModulesCache;
  }
  
  amaModulesCache = {
      prebidScript: 'https://micro.rubiconproject.com/prebid/dynamic/13046.js',
      useLoadDMByAdsLib: true,
      adTags: {},
      useLimitedAds: true,
      useStats: true,
      useVideoStats: true,
      useGLazyLoad: ['responsive_1', 'top_ad'],
    };
 
  return amaModulesCache;
}
  